<template>
    <div>
        <div class="arrow-up"></div> 
        <v-card class="content">
            <v-card-text>

                <div class="page-counters-section">
                    <span class="no-paging-counters" v-if="isPageCountersEmpty">No pages counted</span>
                    <v-simple-table>
                        <tbody>
                            <tr v-for="(userInfo, idx) in $store.state.batchConfig.users" :key="userInfo.user_id" v-if="pageCounters[userInfo.user_username]">
                                <td class="page-container-user-container">
                                    <div class="avatar-container">
                                        <img :src="userInfo.userImage" v-if="userInfo.userImage" />
                                        <v-icon small v-if="!userInfo.userImage">fa fa-user-circle</v-icon>
                                    </div>
                                    <span class="user-text">{{ userInfo.user_username }}</span>
                                </td>
                                <td>
                                    <template v-for="method in [['Email', 'email'], ['SMS', 'sms'], ['Whats App', 'whatsapp'], ['Telegram', 'telegram'], ['Teams', 'teams'], ['Audio', 'audio'], ['Client', 'client_notification'], ['Push', 'push_notification']]">
                                        <div class="method-container" :style="calculatePagingRateStyle(userInfo, method[1])">
                                            <span class="method-label">{{method[0]}}</span>
                                            <span class="method-value">{{$store.state.page_counters[userInfo.user_username][method[1]].length}}/{{userInfo.paging_reduction_settings[`${method[1]}_interval`]}}</span><span>sec</span>
                                        </div>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>

            </v-card-text>
        </v-card>
    </div>
    
</template>

<script>
import _ from 'lodash';
export default {
    name: 'PagingRates',
    props: ['changes'],
    components: {

    },
    data: () => ({
        pagingRateColors: ['#4CAF50', '#8BC34A', '#FFEB3B', '#FF9800', '#F44336'],
    }),

    computed: {
        pageCounters() {
            let c = this.$props.changes;
            return this.$store.state.page_counters;
        },

        isPageCountersEmpty() {
            return _.isEmpty(this.pageCounters);
        }
    },

    methods: {
        calculatePagingRateStyle: function(userInfo, method) {
            let username = userInfo.user_username;
            let pageMethodEnabled = (method == 'email' && userInfo.user_page_email) || (method == 'sms' && userInfo.user_page_smpp && userInfo.user_data.sms_enabled) || (method == 'whatsapp' && userInfo.user_page_smpp && userInfo.user_data.whatsapp_enabled)
                || (method == 'telegram' && userInfo.user_page_smpp && userInfo.user_data.telegram_enabled && userInfo.user_data.telegram_user_id) || (method == 'teams' && userInfo.user_page_teams_url)
                || (method == 'audio') || (method == 'push_notification' && userInfo.user_page_push_notif) || (method == 'client_notification');
            let pageCount = this.$store.state.page_counters[username][method].length;
            if(!pageMethodEnabled) {
                return 'color: #808080;'; // disabled(gray): user paging method isnt enabled/datafilled
            }
            if(!userInfo.paging_reduction_settings[`${method}_enabled`]) {
                return 'color: #FFFFFF;'; // reduction-disabled(white): user paging method is datafilled and reduction is disabled
            }
            if(pageCount === 0) {
                return 'color: #2196F3;'; // no-pages(blue): user paging method is datafilled and reduction is enabled but there is 0 pages in interval
            }
            let threshold = userInfo.paging_reduction_settings[`${method}_threshold`];
            let value = pageCount / threshold;
            let colorWeight = 1 / this.pagingRateColors.length;
            let colorIdx = Math.max(Math.ceil(value / colorWeight) - 1, 0);
            if(value >= 1) {
                return 'color: #F44336; animation: blinker 0.75s linear infinite; @keyframes blinker {50% {color: #000000;}}'; // reduction-active(blink red): paging reduction threshold exceeded
            }
            return `color: ${this.pagingRateColors[colorIdx]};`; // calculated color: user paging method is datafilled and reduction is enabled and there are >0 value
        }
    },

    mounted() {
    }

  
};
</script>

<style scoped>

    .content {
        width: 800px;
        position: relative;
        max-height: 300px;
        overflow-y: auto;
    }

    .arrow-up {
        width: 0; 
        height: 0; 
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: relative;
        left: calc(50% - (100px / 2));
        top: 0px;
        border-bottom: 10px solid #424242;
        z-index: 10;
    }
    @media(max-width: 800px) {
        .arrow-up {
            left: calc(50% + 44px);
        }
    }
    @media(max-width: 670px) {
        .arrow-up {
            left: calc(50% + 84px);
        }
    }
    @media(max-width: 600px) {
        .arrow-up {
            left: calc(50% + 0px);
        }
    }

    .no-paging-counters {
        margin-left: calc(50% - (148px / 2));
        font-size: 18px;
    }

    .page-counters-section {
    }

    .page-container-user-container {
        width: 136px !important; 
        max-width: 140px !important;
        padding-left: 8px !important;
        padding-right: 8px !important;

    }

    .user-text {
        display: inline-block;
        width: calc(100% - (16px + 6px));

    }

    .avatar-container {
        height: 16px;
        width: 16px;
        border-radius: 50%;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
        display: inline-block;
        margin-right: 6px;
    }
    .avatar-container img {
        border-radius: 50%;
        height: 16px;
        width: 16px;
    }

    .method-container {
        display: inline-block;
        width: 75px;
    }

    .method-container .method-label {
        display: block;
        font-size: 12px;
    }
    .method-container .method-value {
        display: inline-block;
        font-weight: bold;
        letter-spacing: 0.5px;
        font-size: 15px;
    }

</style>
